import React, { useEffect, useState } from 'react';
import { useLanguage } from '../App';
import { useTheme } from '../theme';
import { apiUrl, imageUrl } from '../api';

const carBrands = [
  'Abarth', 'Acura', 'Alfa Romeo', 'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Bugatti', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler', 'Citroën', 'Cupra', 'Dacia', 'Daewoo', 'Daihatsu', 'Dodge', 'DS', 'Ferrari', 'Fiat', 'Ford', 'Genesis', 'GMC', 'Honda', 'Hummer', 'Hyundai', 'Infiniti', 'Isuzu', 'Jaguar', 'Jeep', 'Kia', 'Lada', 'Lamborghini', 'Lancia', 'Land Rover', 'Lexus', 'Lincoln', 'Lotus', 'Maserati', 'Mazda', 'McLaren', 'Mercedes', 'MG', 'Mini', 'Mitsubishi', 'Nissan', 'Opel', 'Peugeot', 'Polestar', 'Pontiac', 'Porsche', 'RAM', 'Renault', 'Rolls-Royce', 'Rover', 'Saab', 'Seat', 'Skoda', 'Smart', 'SsangYong', 'Subaru', 'Suzuki', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo', 'Other'
];
const carTypes = ['Sedan', 'SUV', 'Hatchback', 'Coupe', 'Convertible', 'Pickup', 'Van', 'Wagon', 'Other'];
const carYears = Array.from({ length: 30 }, (_, i) => 2025 - i);


export default function Dashboard() {
  const [myCars, setMyCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({ marca: '', model: '', type: '', year: '', price: '' });
  const [busyId, setBusyId] = useState(null);
  const [flash, setFlash] = useState('');
  const [confirmAction, setConfirmAction] = useState(null); // { id, kind: 'status'|'delete', value?: 'sold'|'reserved'|'clear' }
  const { language } = useLanguage();
  const { tokens } = useTheme();
  // Filters & sorting for admin dashboard
  const [filters, setFilters] = useState({ brand: '', model: '', sort: 'newest' });
  const t = {
    en: {
      myListings: 'My Listings',
      marca: 'Brand',
      model: 'Model',
      type: 'Type',
      year: 'Year',
      price: 'Price',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      sold: 'Sold',
      reserved: 'Reserved',
      clear: 'Clear status',
      confirm: 'Confirm',
      dismiss: 'Cancel',
      confirmDeleteTitle: 'Delete listing',
      confirmDeleteMsg: 'Are you sure you want to delete this listing? This action cannot be undone.',
      confirmStatusTitle: 'Update status',
      confirmSoldMsg: 'Mark this listing as Sold? A red ribbon will be shown.',
      confirmReservedMsg: 'Mark this listing as Reserved? A yellow ribbon will be shown.',
      confirmClearMsg: 'Remove status (set to Available)?',
      brandFilter: 'Brand',
      modelFilter: 'Model',
      allBrands: 'All brands',
      allModels: 'All models',
      sortBy: 'Sort by',
      newest: 'Newest',
      oldest: 'Oldest',
      reset: 'Reset',
      noListings: 'No listings added.',
    },
    ro: {
      myListings: 'Anunțurile Mele',
      marca: 'Marcă',
      model: 'Model',
      type: 'Tip',
      year: 'An',
      price: 'Preț',
      edit: 'Editează',
      delete: 'Șterge',
      save: 'Salvează',
      cancel: 'Renunță',
      sold: 'Vândut',
      reserved: 'Rezervat',
      clear: 'Scoate status',
      confirm: 'Confirmă',
      dismiss: 'Renunță',
      confirmDeleteTitle: 'Ștergere anunț',
      confirmDeleteMsg: 'Ești sigur că vrei să ștergi acest anunț? Acțiunea nu poate fi anulată.',
      confirmStatusTitle: 'Actualizare status',
      confirmSoldMsg: 'Marchezi acest anunț ca Vândut? Se va afișa o bandă roșie.',
      confirmReservedMsg: 'Marchezi acest anunț ca Rezervat? Se va afișa o bandă galbenă.',
      confirmClearMsg: 'Scoți statusul (disponibil)?',
      brandFilter: 'Marcă',
      modelFilter: 'Model',
      allBrands: 'Toate mărcile',
      allModels: 'Toate modelele',
      sortBy: 'Sortează după',
      newest: 'Cele mai noi',
      oldest: 'Cele mai vechi',
      reset: 'Resetează',
      noListings: 'Nu există anunțuri adăugate.',
    }
  };
  const tr = t[language];

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(apiUrl('/api/cars'), {
      headers: { Authorization: token }
    })
      .then(res => res.json())
      .then(data => {
        setMyCars(data);
      })
      .catch(() => {
        setMyCars([]);
      })
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Removed unused direct deletion handler (delete handled via confirmAction flow)

  const handleEdit = (car) => {
    setEditId(car._id);
    setEditData({ marca: car.marca || car.brand || '', model: car.model || '', type: car.type || '', year: car.year || '', price: car.price || '' });
  };

  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEditSave = async () => {
    const token = localStorage.getItem('token');
    await fetch(apiUrl(`/api/cars/${editId}`), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify(editData)
    });
    setMyCars(myCars.map(car => car._id === editId ? { ...car, ...editData } : car));
    setEditId(null);
  };

  const performStatusUpdate = async (carId, next) => {
    const token = localStorage.getItem('token');
    const body = next === 'clear' ? { sold: false, status: 'available' } : (next === 'sold' ? { sold: true, status: 'sold' } : { status: 'reserved' });
    setBusyId(carId);
    try {
      const resp = await fetch(apiUrl(`/api/cars/${carId}`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify(body)
      });
      if (!resp.ok) throw new Error(await resp.text());
      setMyCars(prev => prev.map(c => c._id === carId ? { ...c, ...body } : c));
      const labels = { sold: tr.sold, reserved: tr.reserved, clear: tr.clear };
      setFlash(`Status actualizat: ${labels[next] || ''}`);
      setTimeout(() => setFlash(''), 1500);
    } catch (e) {
      alert('Actualizarea statusului a eșuat. Încercați din nou.');
    } finally {
      setBusyId(null);
      setConfirmAction(null);
    }
  };

  const performDelete = async (carId) => {
    const token = localStorage.getItem('token');
    setBusyId(carId);
    try {
      const resp = await fetch(apiUrl(`/api/cars/${carId}`), {
        method: 'DELETE',
        headers: { Authorization: token }
      });
      if (!resp.ok) throw new Error(await resp.text());
      setMyCars(prev => prev.filter(c => c._id !== carId));
      setFlash('Anunț șters');
      setTimeout(() => setFlash(''), 1500);
    } catch (e) {
      alert('Ștergerea a eșuat. Încercați din nou.');
    } finally {
      setBusyId(null);
      setConfirmAction(null);
    }
  };

  const carsArray = Array.isArray(myCars) ? myCars : [];
  // Helpers for brand/model derivation and sorting
  const uniqueSorted = (arr) => Array.from(new Set(arr.filter(Boolean).map(v => `${v}`.trim()))).sort((a, b) => a.localeCompare(b));
  const deriveBrand = (c) => {
    const b = (c?.marca || c?.brand || '').toString().trim();
    if (b) return b;
    const title = (c?.title || '').toString().trim();
    return title ? title.split(/\s+/)[0] : '';
  };
  const allBrands = uniqueSorted(carsArray.map(deriveBrand));
  const modelsByBrand = carsArray.reduce((acc, c) => {
    const b = deriveBrand(c);
    const m = (c?.model || '').toString().trim();
    if (!b || !m) return acc;
    if (!acc[b]) acc[b] = new Set();
    acc[b].add(m);
    return acc;
  }, {});
  const modelsForSelectedBrand = filters.brand
    ? uniqueSorted(Array.from(modelsByBrand[filters.brand] || []))
    : uniqueSorted(carsArray.map(c => (c?.model || '').toString().trim()));

  const filteredCars = carsArray
    .filter(c => {
      const b = deriveBrand(c);
      const m = (c?.model || '').toString().trim();
      if (filters.brand && b !== filters.brand) return false;
      if (filters.model && m !== filters.model) return false;
      return true;
    })
    .sort((a, b) => {
      const da = new Date(a.createdAt || 0).getTime();
      const db = new Date(b.createdAt || 0).getTime();
      return filters.sort === 'oldest' ? da - db : db - da;
    });
  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'brand' ? { model: '' } : {})
    }));
  };
  const resetFilters = () => setFilters({ brand: '', model: '', sort: 'newest' });
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 16px' }}>
      <h2 style={{ fontSize: 32, fontWeight: 700, marginBottom: 16, textAlign: 'center', letterSpacing: 1, color: tokens.text }}>{tr.myListings}</h2>
      {/* Filters bar */}
      <div style={{
        background: tokens.surface,
        border: `1px solid ${tokens.border}`,
        borderRadius: 12,
        boxShadow: `0 6px 20px ${tokens.shadow}`,
        padding: 16,
        margin: '0 auto 20px auto',
        maxWidth: 980,
        color: tokens.text,
      }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'end' }}>
          <div style={{ minWidth: 180, flex: '1 1 200px' }}>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: tokens.text }}>{tr.brandFilter}</div>
            <select name="brand" value={filters.brand} onChange={onChangeFilter} style={selectStyle(tokens)}>
              <option value="">{tr.allBrands}</option>
              {allBrands.map(b => (
                <option key={b} value={b}>{b}</option>
              ))}
            </select>
          </div>
          <div style={{ minWidth: 180, flex: '1 1 200px' }}>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: tokens.text }}>{tr.modelFilter}</div>
            <select name="model" value={filters.model} onChange={onChangeFilter} disabled={!filters.brand && modelsForSelectedBrand.length===0} style={{
              ...selectStyle(tokens),
              ...(filters.brand ? {} : { background: tokens.surface, color: tokens.textMuted, border: `1px solid ${tokens.border}` })
            }}>
              <option value="">{tr.allModels}</option>
              {modelsForSelectedBrand.map(m => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          </div>
          <div style={{ minWidth: 180, flex: '1 1 200px' }}>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6, color: tokens.text }}>{tr.sortBy}</div>
            <select name="sort" value={filters.sort} onChange={onChangeFilter} style={selectStyle(tokens)}>
              <option value="newest">{tr.newest}</option>
              <option value="oldest">{tr.oldest}</option>
            </select>
          </div>
          <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
            <button onClick={resetFilters} style={{ background: 'transparent', color: tokens.text, border: `1px solid ${tokens.mutedBorder}`, borderRadius: 8, padding: '10px 14px', fontWeight: 700 }}>{tr.reset}</button>
          </div>
        </div>
      </div>
      {(!loading && carsArray.length === 0) ? (
        <div style={{ color: '#ff5252', fontSize: 22, textAlign: 'center', marginTop: 32 }}>{tr.noListings}</div>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, justifyContent: 'center' }}>
          {filteredCars.map(car => (
          <div key={car._id} style={{
            background: tokens.surface,
            borderRadius: 16,
            boxShadow: `0 4px 24px ${tokens.shadow}`,
            padding: 24,
            width: 320,
            color: tokens.text,
            transition: 'transform 0.2s, box-shadow 0.2s',
            cursor: 'pointer',
            border: 'none',
            position: 'relative',
            overflow: 'hidden',
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            {car.image && <img src={imageUrl(car.image)} alt={car.title || car.model} style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: 12, marginBottom: 16, boxShadow: `0 2px 8px ${tokens.shadowSoft}` }} />}
            <h3 style={{ fontSize: 24, fontWeight: 600, margin: '8px 0 4px' }}>{car.marca || car.brand || (car.title ? (car.title.split(' ')[0]) : car.model)}</h3>
            {(car.status === 'sold' || car.sold) && (
              <div style={{ position: 'absolute', top: 16, left: -46, transform: 'rotate(-45deg)', background: 'linear-gradient(90deg, #ef4444, #dc2626)', color: '#fff', fontWeight: 900, width: 150, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, letterSpacing: 1, textTransform: 'uppercase', boxShadow: '0 4px 10px #0006' }}>{tr.sold}</div>
            )}
            {car.status === 'reserved' && (
              <div style={{ position: 'absolute', top: 16, left: -46, transform: 'rotate(-45deg)', background: 'linear-gradient(90deg, #fbbf24, #f59e0b)', color: '#1b1b1b', fontWeight: 900, width: 150, height: 26, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, letterSpacing: 1, textTransform: 'uppercase', boxShadow: '0 4px 10px #0006' }}>{tr.reserved}</div>
            )}
            {editId === car._id ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <label style={{ fontWeight: 600 }}>{tr.marca}</label>
                <select name="marca" value={editData.marca} onChange={handleEditChange} style={getInputStyle(tokens)}>
                  {[editData.marca, ...carBrands.filter(b => b !== editData.marca)].map(b => (
                    <option key={b} value={b}>{b}</option>
                  ))}
                </select>
                <label style={{ fontWeight: 600 }}>{tr.model}</label>
                <input name="model" value={editData.model} onChange={handleEditChange} style={getInputStyle(tokens)} />
                <label style={{ fontWeight: 600 }}>{tr.type}</label>
                <select name="type" value={editData.type} onChange={handleEditChange} style={getInputStyle(tokens)}>
                  {[editData.type, ...carTypes.filter(t => t !== editData.type)].map(t => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
                <label style={{ fontWeight: 600 }}>{tr.year}</label>
                <select name="year" value={editData.year} onChange={handleEditChange} style={getInputStyle(tokens)}>
                  {[editData.year, ...carYears.filter(y => y !== editData.year)].map(y => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
                <label style={{ fontWeight: 600 }}>{tr.price}</label>
                <input name="price" value={editData.price} onChange={handleEditChange} style={getInputStyle(tokens)} />
                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                  <button onClick={handleEditSave} style={{ background: `linear-gradient(90deg, ${tokens.accent} 0%, ${tokens.accent2} 100%)`, color: tokens.inverse, border: 'none', borderRadius: 8, padding: '8px 16px', fontWeight: 600, cursor: 'pointer', transition: 'background 0.2s' }}>{tr.save}</button>
                  <button onClick={() => setEditId(null)} style={{ background: tokens.panel, color: tokens.text, border: `1px solid ${tokens.mutedBorder}`, borderRadius: 8, padding: '8px 16px', fontWeight: 600, cursor: 'pointer', transition: 'background 0.2s' }}>{tr.cancel}</button>
                </div>
              </div>
            ) : (
              <>
                {/* Small delete button in the top-right corner (same style family as BuyBack, smaller) */}
                <button
                  onClick={() => setConfirmAction({ id: car._id, kind: 'delete' })}
                  title={tr.delete}
                  style={{
                    position: 'absolute',
                    bottom: 10,
                    right: 10,
                    width: 36,
                    height: 36,
                    background: '#ef4444',
                    color: '#fff',
                    borderRadius: 10,
                    border: '1px solid #b91c1c',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.45)'
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 6h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" stroke="currentColor" strokeWidth="2"/>
                    <path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </button>
                <p style={{ margin: '4px 0', fontSize: 16 }}><b>{tr.marca}:</b> {car.marca || car.brand || (car.title ? (car.title.split(' ')[0]) : '')}</p>
                <p style={{ margin: '4px 0', fontSize: 16 }}><b>{tr.model}:</b> {car.model}</p>
                <p style={{ margin: '4px 0', fontSize: 16 }}><b>{tr.type}:</b> {car.type}</p>
                <p style={{ margin: '4px 0', fontSize: 16 }}><b>{tr.year}:</b> {car.year}</p>
                <p style={{ margin: '4px 0', fontSize: 16 }}><b>{tr.price}:</b> <span style={{ color: tokens.accent, fontWeight: 700 }}>{(() => { const s=String(car.price??'').replace(/[^0-9]/g,''); return s? s.replace(/\B(?=(\d{3})+(?!\d))/g,' ') + ' €' : '—'; })()}</span></p>
                <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
                  <button onClick={() => handleEdit(car)} style={{ background: tokens.panel, color: tokens.text, border: `1px solid ${tokens.mutedBorder}`, borderRadius: 8, padding: '8px 16px', fontWeight: 600, cursor: 'pointer', transition: 'background 0.2s' }}>{tr.edit}</button>
                  <button disabled={busyId===car._id} onClick={() => setConfirmAction({ id: car._id, kind: 'status', value: 'sold' })} style={{ opacity: busyId===car._id?0.6:1, background: 'linear-gradient(90deg, #ef4444, #dc2626)', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontWeight: 700, cursor: 'pointer' }}>{busyId===car._id ? '...' : tr.sold}</button>
                  <button disabled={busyId===car._id} onClick={() => setConfirmAction({ id: car._id, kind: 'status', value: 'reserved' })} style={{ opacity: busyId===car._id?0.6:1, background: 'linear-gradient(90deg, #fbbf24, #f59e0b)', color: '#111', border: 'none', borderRadius: 8, padding: '8px 16px', fontWeight: 800, cursor: 'pointer' }}>{busyId===car._id ? '...' : tr.reserved}</button>
                  <button disabled={busyId===car._id} onClick={() => setConfirmAction({ id: car._id, kind: 'status', value: 'clear' })} style={{ opacity: busyId===car._id?0.6:1, background: tokens.panel, color: tokens.text, border: `1px solid ${tokens.border}`, borderRadius: 8, padding: '8px 16px', fontWeight: 700, cursor: 'pointer' }}>{busyId===car._id ? '...' : tr.clear}</button>
                </div>

                {/* Inline confirmation overlay anchored to this card */}
                {confirmAction?.id === car._id && (
                  <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 5 }}>
                    <div style={{ width: 300, background: tokens.surface, border: `1px solid ${tokens.border}`, borderRadius: 12, padding: 16, boxShadow: `0 12px 38px ${tokens.shadow}` }}>
                      <div style={{ color: tokens.text, fontWeight: 800, marginBottom: 6 }}>
                        {confirmAction.kind === 'delete' ? tr.confirmDeleteTitle : tr.confirmStatusTitle}
                      </div>
                      <div style={{ color: tokens.textMuted, fontSize: 14, marginBottom: 12 }}>
                        {confirmAction.kind === 'delete' ? (
                          tr.confirmDeleteMsg
                        ) : confirmAction.value === 'sold' ? (
                          tr.confirmSoldMsg
                        ) : confirmAction.value === 'reserved' ? (
                          tr.confirmReservedMsg
                        ) : (
                          tr.confirmClearMsg
                        )}
                      </div>
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                        <button onClick={() => setConfirmAction(null)} style={{ background: 'transparent', color: tokens.text, border: `1px solid ${tokens.border}`, borderRadius: 8, padding: '8px 12px', fontWeight: 700 }}>{tr.dismiss}</button>
                        <button disabled={busyId===car._id} onClick={() => (confirmAction.kind === 'delete' ? performDelete(car._id) : performStatusUpdate(car._id, confirmAction.value))} style={{ opacity: busyId===car._id?0.7:1, background: `linear-gradient(90deg, ${tokens.accent}, ${tokens.accent2})`, color: tokens.inverse, border: 'none', borderRadius: 8, padding: '8px 12px', fontWeight: 900 }}>
                          {busyId===car._id ? '...' : tr.confirm}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            <div style={{ position: 'absolute', top: 0, right: 0, width: 0, height: 0, borderTop: `40px solid ${tokens.accent}`, borderLeft: '40px solid transparent' }}></div>
          </div>
          ))}
        </div>
      )}
    </div>
  );
}

function getInputStyle(tokens) {
  return {
    background: tokens.panel,
    color: tokens.text,
    border: `1px solid ${tokens.mutedBorder}`,
    borderRadius: 8,
    padding: '10px 12px',
    fontSize: 16,
    marginBottom: 0,
  };
}

function selectStyle(tokens) {
  return {
    ...getInputStyle(tokens),
    width: '100%',
    cursor: 'pointer',
  };
}
